<template>
  <div class="white relative col-12">
      <div class="p3">
        <h2 class="h2 light">{{$t('creator_profile_administration_heading')}}</h2>
        <p class="mb3 color-mediumgray">{{$t('creator_profile_administration_subtitle')}}</p>
        <div v-for="profile in creator_profiles" :key="profile.id">
          <div @click="selectCreatorProfile(profile.id)" class="flex py2 pl2 align-middle justify-between pointer user-profile-bar">
            <h3 class="h4">{{profile.title}}</h3>
            <div class="flex align-middle justify-between pr3 border-box">
                  <div v-on:click.stop="editCreatorProfile(profile)">
                      <svg class="mx2 pointer" width="20" height="20" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M6.80401 7.34305C6.93545 7.6739 6.85286 8.0551 6.59776 8.29509L6.30448 8.5708C6.24298 8.62853 6.20788 8.71071 6.20788 8.79695C6.20788 8.88318 6.24298 8.96536 6.30448 9.02309L6.59776 9.29934C6.85309 9.53916 6.93581 9.92044 6.80432 10.2513C6.67282 10.5822 6.35558 10.791 6.01224 10.7727L5.61704 10.7515C5.5341 10.7465 5.45311 10.7791 5.395 10.8409C5.33652 10.9018 5.30553 10.9857 5.30972 11.0717L5.33 11.4833C5.34728 11.8408 5.14735 12.171 4.83028 12.3088C4.73143 12.3517 4.62536 12.3736 4.51828 12.3733C4.28814 12.3731 4.06874 12.2718 3.91404 12.0943L3.64936 11.7883C3.59237 11.7272 3.51406 11.6927 3.43226 11.6927C3.35047 11.6927 3.27215 11.7272 3.21516 11.7883L2.94996 12.0943C2.71958 12.3601 2.35362 12.4461 2.036 12.3092C1.71839 12.1723 1.5178 11.842 1.53504 11.4844L1.55532 11.0722C1.55939 10.9861 1.52831 10.9022 1.46978 10.8412C1.41124 10.7802 1.33069 10.7479 1.248 10.7521L0.854363 10.7732C0.510962 10.7914 0.193715 10.5826 0.0621389 10.2517C-0.0694377 9.92075 0.0131288 9.53939 0.268323 9.29934L0.561603 9.02363C0.623101 8.96591 0.658211 8.88372 0.658211 8.79749C0.658211 8.71125 0.623101 8.62907 0.561603 8.57134L0.268323 8.29509C0.0131288 8.05504 -0.0694377 7.67369 0.0621389 7.34278C0.193715 7.01186 0.510962 6.80301 0.854363 6.82122L1.24904 6.84234C1.33215 6.84924 1.41378 6.81658 1.47108 6.75351C1.52951 6.69258 1.56049 6.60877 1.55636 6.52276L1.53608 6.11109C1.51836 5.75328 1.71878 5.42259 2.03652 5.28539C2.35425 5.14818 2.7205 5.23417 2.951 5.50009L3.2162 5.80667C3.27326 5.86766 3.35155 5.90205 3.4333 5.90205C3.51506 5.90205 3.59334 5.86766 3.6504 5.80667L3.91508 5.50063C4.14547 5.2349 4.51143 5.14888 4.82904 5.28579C5.14666 5.4227 5.34725 5.75294 5.33 6.11055L5.30972 6.52222C5.30551 6.6084 5.33649 6.69242 5.395 6.75351C5.45343 6.81481 5.53424 6.84714 5.61704 6.84234L6.01224 6.82122C6.35555 6.80325 6.67258 7.0122 6.80401 7.34305ZM1.90271 8.7972C1.90271 9.67702 2.58741 10.3902 3.43203 10.3902C4.2763 10.3894 4.96049 9.67665 4.96135 8.7972C4.96135 7.91739 4.27665 7.20416 3.43203 7.20416C2.58741 7.20416 1.90271 7.91739 1.90271 8.7972Z" fill="#ffffff"/>
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M11.9184 4.42975L12.2117 4.706L12.2143 4.70546C12.4695 4.94551 12.552 5.32686 12.4205 5.65777C12.2889 5.98868 11.9716 6.19754 11.6282 6.17933L11.2336 6.15821C11.1507 6.15291 11.0697 6.18532 11.0115 6.24704C10.9531 6.30796 10.9221 6.39178 10.9262 6.47779L10.9465 6.88946C10.9636 7.24728 10.7629 7.57767 10.4452 7.71496C10.3464 7.75772 10.2403 7.77945 10.1332 7.77887C9.90317 7.77891 9.68376 7.67781 9.529 7.50046L9.2638 7.19387C9.20689 7.13261 9.12855 7.09803 9.0467 7.09803C8.96486 7.09803 8.88652 7.13261 8.8296 7.19387L8.56492 7.49992C8.33454 7.76565 7.96858 7.85167 7.65096 7.71476C7.33335 7.57785 7.13276 7.24761 7.15 6.89L7.17028 6.47779C7.17452 6.39192 7.14352 6.30823 7.085 6.24758C7.02619 6.18684 6.9457 6.15444 6.86296 6.15821L6.46776 6.17933C6.12446 6.1973 5.80743 5.98835 5.67599 5.6575C5.54456 5.32665 5.62714 4.94544 5.88224 4.70546L6.17552 4.42921C6.23702 4.37148 6.27213 4.28929 6.27213 4.20306C6.27213 4.11683 6.23702 4.03464 6.17552 3.97692L5.88224 3.70067C5.62692 3.46085 5.54419 3.07957 5.67569 2.74869C5.80719 2.4178 6.12442 2.20899 6.46776 2.22733L6.86296 2.24846C6.94624 2.25586 7.02815 2.22289 7.085 2.15908C7.14343 2.09816 7.17441 2.01434 7.17028 1.92833L7.15 1.51667C7.133 1.15916 7.33367 0.829141 7.65123 0.692377C7.96878 0.555612 8.3346 0.641656 8.56492 0.907291L8.8296 1.21333C8.88666 1.27432 8.96495 1.30871 9.0467 1.30871C9.12846 1.30871 9.20674 1.27432 9.2638 1.21333L9.529 0.90675C9.75939 0.641019 10.1253 0.554993 10.443 0.691905C10.7606 0.828817 10.9612 1.15906 10.9439 1.51667L10.9236 1.92887C10.9195 2.01488 10.9505 2.0987 11.0089 2.15962C11.0677 2.22048 11.1482 2.2529 11.231 2.249L11.6256 2.22787C11.9691 2.20929 12.2865 2.41801 12.4182 2.74895C12.5498 3.0799 12.4671 3.46133 12.2117 3.70121L11.9184 3.97746C11.8569 4.03518 11.8218 4.11737 11.8218 4.2036C11.8218 4.28984 11.8569 4.37202 11.9184 4.42975ZM7.63509 4.81242C7.8718 5.4077 8.42944 5.79583 9.048 5.79583C9.89214 5.79464 10.5762 5.08211 10.5773 4.20279C10.5773 3.55847 10.2047 2.97759 9.63324 2.73101C9.06177 2.48444 8.40399 2.62073 7.9666 3.07634C7.52922 3.53195 7.39838 4.21714 7.63509 4.81242Z" fill="#ffffff"/>
                      </svg>
                  </div>
                  <div v-on:click.stop="deleteCreatorProfile(profile)">
                      <svg class="pointer" style="margin-right: 12px" width="20" height="20" viewBox="0 0 10 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M8.32434 3.59296H1.74542C1.62431 3.59296 1.52612 3.7002 1.52612 3.83249V10.5394C1.52612 11.0685 1.91885 11.4975 2.40331 11.4975H7.66645C8.15091 11.4975 8.54364 11.0685 8.54364 10.5394V3.83249C8.54364 3.7002 8.44546 3.59296 8.32434 3.59296ZM4.2674 9.82075C4.2674 10.0192 4.12012 10.18 3.93845 10.18C3.75678 10.18 3.60951 10.0192 3.60951 9.82075V5.50919C3.60951 5.31076 3.75678 5.14989 3.93845 5.14989C4.12012 5.14989 4.2674 5.31076 4.2674 5.50919V9.82075ZM6.13146 10.18C6.31314 10.18 6.46042 10.0192 6.46042 9.82075V5.50919C6.46042 5.31076 6.31314 5.14989 6.13146 5.14989C5.94978 5.14989 5.80251 5.31076 5.80251 5.50919V9.82075C5.80251 10.0192 5.94978 10.18 6.13146 10.18Z" fill="#EE0044"/>
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M7.33765 1.91624H9.42099C9.66322 1.91624 9.85959 2.13073 9.85959 2.39531C9.85959 2.65988 9.66322 2.87437 9.42099 2.87437H0.649046C0.406816 2.87437 0.210449 2.65988 0.210449 2.39531C0.210449 2.13073 0.406816 1.91624 0.649046 1.91624H2.73238C2.76146 1.91624 2.78935 1.90363 2.80992 1.88117C2.83048 1.85871 2.84203 1.82824 2.84203 1.79648V1.19765C2.84203 0.536207 3.33295 0 3.93853 0H6.13151C6.73709 0 7.228 0.536207 7.228 1.19765V1.79648C7.228 1.86262 7.2771 1.91624 7.33765 1.91624ZM3.71909 1.19765V1.79648C3.71909 1.86262 3.76818 1.91624 3.82873 1.91624H6.24101C6.30157 1.91624 6.35066 1.86262 6.35066 1.79648V1.19765C6.35066 1.06536 6.25248 0.958115 6.13136 0.958115H3.93838C3.81727 0.958115 3.71909 1.06536 3.71909 1.19765Z" fill="#EE0044"/>
                      </svg>
                  </div>
            </div>
          </div>
          <div class="divider mx0"></div>
        </div>
        <div @click="newCreatorProfile()" class="p1 relative mx-auto mt3 pointer" style="border-radius: 30px; height:30px; width:30px; border: 1px solid white;">
          <svg style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 1V23" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M23 12H1" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
    </div>
    

  <lightbox activateCommand="open_updateCreatorProfileModal" deactivateCommand="close_updateCreatorProfileModal" customClass="bg-color-darkgray rounded-border ui-modal--settings" special_lightbox="update_creatorProfile_lightbox">
        <div class="flex flex-wrap col-12 max-width-4 ui-modal  ui-modal--settings ">
            <div class="col-6">
            <div class="flex align-middle mb1">
                <p class="col-4 small" v-bind:class="{ userprofileError: not_filled_title}">{{$t('creator_profile_administration_profile_name')}}*</p>
            <input class="user-input-narrow col-8 border-box" :placeholder="$t('creator_profile_administration_profile_name_placeholder')" v-model="userProfile.title">
            </div>
          
            <div class="flex align-middle mb1">
                <p class="col-4 small" v-bind:class="{ userprofileError: not_filled_company}">{{$t('creator_profile_administration_company')}}*</p>
                <input class="user-input-narrow col-8 border-box" :placeholder="$t('creator_profile_administration_company_placeholder')" v-model="userProfile.company">
            </div>
                <div class="flex align-middle rowsys mb1">
                <p class="small col-4" v-bind:class="{ userprofileError: not_filled_email}">{{$t('creator_profile_administration_email')}}*</p>
                <input class="user-input-narrow col-8 border-box" :placeholder="$t('creator_profile_administration_email_placeholder')" v-model="userProfile.email">
            </div> 
            <div class="flex align-middle mb1">
                <p class="col-4 small " v-bind:class="{ userprofileError: not_filled_phone}">{{$t('creator_profile_administration_phone')}}*</p>
                <input class="user-input-narrow col-8 border-box" :placeholder="$t('creator_profile_administration_phone_placeholder')" v-model="userProfile.phone">
            </div>
            <div class="flex align-middle mb1">
                <p class="col-4 small" v-bind:class="{ userprofileError: not_filled_creator_name}">{{$t('creator_profile_administration_creator_name')}}*</p>
                <input class="user-input-narrow col-8 border-box" :placeholder="$t('creator_profile_administration_creator_name_placeholder')" v-model="userProfile.creator_name">
            </div>
            </div>
            <div class="col-6 pl2 border-box ">
            <div class="flex align-middle mb1 col-12">
                <p class="col-4  small" v-bind:class="{ userprofileError: not_filled_address1}">{{$t('creator_profile_administration_address_1')}}*</p>
                <input class="user-input-narrow  col-8 border-box" v-model="userProfile.address1"/>
            </div>
            <div class="flex align-middle mb1 col-12 row-sys">
                <p class="col-4 small">{{$t('creator_profile_administration_address_2')}}</p>
                <input class="user-input-narrow  col-8 border-box" v-model="userProfile.address2"/>
            </div>
            <div class="flex align-middle mb1 col-12 row-sys">
                <p class="col-4 small">{{$t('creator_profile_administration_address_3')}}</p>
                <input class="user-input-narrow  col-8 border-box" v-model="userProfile.address3"/>
            </div>
            <div class="flex align-middle mb1 col-12 row-sys">
                <p class="col-4  small " v-bind:class="{ userprofileError: not_filled_country}">{{$t('creator_profile_administration_country')}}*</p>
                <div class="relative user-select-wrapper col-8 border-box">
                <img class="dropdown-arrow" src="../assets/dropdown-arrow.svg">
                <select class="user-input-narrow  col-12" id="CountrySelect" name="CountrySelect" v-model="userProfile.country_id">
                    <option value="" disabled>{{$t('creator_profile_administration_country')}}</option>
                    <option v-for="country in countries_list.data" :key="country.id" :value="country.id">
                    {{ country.countryname }}
                    </option>
                </select> 
                </div>
            </div>
            <div class="flex mt1">
                <div class="col-4">
                <p class="small ">{{$t('creator_profile_administration_logo')}}</p>
                <p class="color-mediumgray  small mr2">{{$t('creator_profile_administration_logo_maxMB')}}</p>
                </div>
                <!-- <img :src="userProfile.previewimage"> -->
                <div class="flex mb2 col-8">
                <div v-if="userProfile.previewimage !== ''" @click="selectImage"  :style="{ 'background-image': `url(${userProfile.previewimage.replace(/(\r\n|\n|\r)/gm, '')})` }" class="p4 rounded-border overflow-hidden bg-color-gray company-img-container"></div>
                <div>
                    <input class="hidden-file-upload" ref="fileInput" type="file" name="Datei hochladen" @input="pickFile"> 
                    <div class="flex flex-column" :class="{'ml3': userProfile.previewimage !== ''}">
                    <button class="btn btn-tiny pointer mb2" @click="selectImage">{{$t('creator_profile_administration_upload_pic')}}</button>
                    <button class="btn btn-bg-red btn-small pointer" v-if="userProfile.previewimage !== ''" @click="userProfile.previewimage = ''">{{$t('creator_profile_administration_delete_pic')}}</button>
                    </div>
                </div>
                </div>
            </div>
            </div>
        </div>
         <div class="divider my2 mx0 col-12"></div>
        <div class="col-12 flex justify-end ">
         
          <button class="btn btn-bg-red btn-small pointer" @click="closeUpdateCreatorProfile()">{{$t('creator_profile_administration_cancel')}}</button>
          <button class="btn btn-small pointer ml3" @click="updateCreatorProfile()">{{$t('creator_profile_administration_save_changes')}}</button>
        </div>
    </lightbox>
    
    <lightbox activateCommand="open_addCreatorProfileModal" deactivateCommand="close_addCreatorProfileModal" customClass="bg-color-darkgray rounded-border">
        <div class="flex flex-wrap col-12 max-width-4 ui-modal  ui-modal--settings ">
            <div class="col-6">
            <div class="flex align-middle mb1">
                <p class="col-4 small" v-bind:class="{ userprofileError: not_filled_title}">{{$t('creator_profile_administration_profile_name')}}*</p>
            <input class="user-input-narrow col-8 border-box" :placeholder="$t('creator_profile_administration_profile_name_placeholder')" v-model="userProfile.title">
            </div>
          
            <div class="flex align-middle mb1">
                <p class="col-4 small" v-bind:class="{ userprofileError: not_filled_company}">{{$t('creator_profile_administration_company')}}*</p>
                <input class="user-input-narrow col-8 border-box" :placeholder="$t('creator_profile_administration_company_placeholder')" v-model="userProfile.company">
            </div>
                <div class="flex align-middle rowsys mb1">
                <p class="small col-2" v-bind:class="{ userprofileError: not_filled_email}">{{$t('creator_profile_administration_email')}}*</p>
                <div class="col-2">
                <div class="switch relative dark pointer" @click="changeFreeMail(userProfile.freeMail)">
                    <div class="switch-ball" :class="{sbLeft: userProfile.freeMail == 0}"></div>
                </div> 
                </div>
                <input v-show="userProfile.freeMail == 1" class="user-input-narrow col-8 border-box" :placeholder="$t('creator_profile_administration_email_placeholder')" v-model="userProfile.email">
                <input disabled v-show="userProfile.freeMail == 0" class="user-input-narrow  no-border col-8 border-box npe" :placeholder="$t('creator_profile_administration_email_placeholder')" v-model="userdata.email">
            </div> 
                <div class="flex align-middle mb1">
                <p class="col-2 small " v-bind:class="{ userprofileError: not_filled_phone}">{{$t('creator_profile_administration_phone')}}*</p>
                <div class="col-2">
                <div class="switch dark relative pointer" @click="changeFreePhone(userProfile.freePhone)">
                    <div class="switch-ball" :class="{sbLeft: userProfile.freePhone == 0}"></div>
                </div> 
                </div>
                <input v-show="userProfile.freePhone == 1" class="user-input-narrow col-8 border-box" :placeholder="$t('creator_profile_administration_phone_placeholder')" v-model="userProfile.phone">
                <input disabled v-show="userProfile.freePhone == 0" class="user-input-narrow  no-border col-8 border-box npe" :placeholder="$t('creator_profile_administration_phone_placeholder')" v-model="userdata.tel">
            </div>
            <div class="flex align-middle mb1">
                <p class="col-4 small" v-bind:class="{ userprofileError: not_filled_creator_name}">{{$t('creator_profile_administration_creator_name')}}*</p>
                <input class="user-input-narrow col-8 border-box" :placeholder="$t('creator_profile_administration_creator_name')" v-model="userProfile.creator_name">
            </div>
            </div>
            <div class="col-6 pl2 border-box ">
            <div class="flex align-middle mb1 col-12">
                <p class="col-4  small" v-bind:class="{ userprofileError: not_filled_address1}">{{$t('creator_profile_administration_address_1')}}*</p>
                <input class="user-input-narrow  col-8 border-box" v-model="userProfile.address1"/>
            </div>
            <div class="flex align-middle mb1 col-12 row-sys">
                <p class="col-4 small">{{$t('creator_profile_administration_address_2')}}</p>
                <input class="user-input-narrow  col-8 border-box" v-model="userProfile.address2"/>
            </div>
            <div class="flex align-middle mb1 col-12 row-sys">
                <p class="col-4 small">{{$t('creator_profile_administration_address_3')}}</p>
                <input class="user-input-narrow  col-8 border-box" v-model="userProfile.address3"/>
            </div>
            <div class="flex align-middle mb1 col-12 row-sys">
                <p class="col-4  small " v-bind:class="{ userprofileError: not_filled_country}">{{$t('creator_profile_administration_country')}}*</p>
                <div class="relative user-select-wrapper col-8 border-box">
                <img class="dropdown-arrow" src="../assets/dropdown-arrow.svg">
                <select class="user-input-narrow  col-12" id="CountrySelect" name="CountrySelect" v-model="userProfile.country_id">
                    <option value="" disabled>{{$t('creator_profile_administration_country')}}</option>
                    <option v-for="country in countries_list.data" :key="country.id" :value="country.id">
                    {{ country.countryname }}
                    </option>
                </select> 
                </div>
            </div>
            <div class="flex mt2">
                <div class="col-4">
                 <p class="small ">{{$t('creator_profile_administration_logo')}}</p>
                <p class="color-mediumgray  small mr2">{{$t('creator_profile_administration_logo_maxMB')}}</p>
                </div>
                <!-- <img :src="userProfile.previewimage"> -->
                <div class="flex mb1 col-8">
                <div v-if="userProfile.previewimage !== ''" @click="selectImage"  :style="{ 'background-image': `url(${userProfile.previewimage.replace(/(\r\n|\n|\r)/gm, '')})` }" class="p4 rounded-border overflow-hidden bg-color-gray company-img-container"></div>
                <div class="">
                    <input class="hidden-file-upload" ref="fileInput" type="file" name="Datei hochladen" @input="pickFile"> 
                    <div class="flex flex-column" :class="{'ml3': userProfile.previewimage !== ''}">
                    <button class="btn btn-tiny pointer mb2" @click="selectImage">{{$t('creator_profile_administration_upload_pic')}}</button>
                    <button class="btn btn-bg-red btn-small pointer" v-if="userProfile.previewimage !== ''" @click="userProfile.previewimage = ''">{{$t('creator_profile_administration_delete_pic')}}</button>
                    </div>
                </div>
                </div>
            </div>
            </div>
        </div>
         <div class="divider my2 mx0 col-12"></div>
        <div class="col-12 flex justify-end ">
         
          <button class="btn btn-bg-red btn-small pointer" @click="closeAddCreatorProfile()">{{$t('creator_profile_administration_cancel')}}</button>
          <button class="btn btn-small pointer ml3" @click="addCreatorProfile()">{{$t('creator_profile_administration_add_profile')}}</button>
        </div>
    </lightbox>

  </div>
</template>

<script>
import axios from 'axios';
import { EventBus } from "../event-bus";
import lightbox from './lightbox.vue';

export default {
  name: 'creatorProfiles',
  data() {
    return {
      debug: false,
      selected_creator_profile: '',
      showCreatorProfileEditModal: false,
      showCreatorProfileCreationModal: false,
      creator_profiles: [],
      userProfile: {
        id: 0,
        title: '',
        previewimage: '',
        address1: '',
        address2: '',
        address3: '',
        company: '',
        email: '',
        phone: '',
        freePhone: 0,
        freeMail: 0,
        creator_name: '',
        country_id: ''
      },

      not_filled_title: false,
      not_filled_firstname: false,
      not_filled_lastname: false,
      not_filled_company: false,
      not_filled_email: false,
      not_filled_country: false,
      not_filled_address1: false,
      not_filled_creator_name: false,
      not_filled_phone: false,
      not_same_password: false,
      not_old_password: false,
      not_filled_previewimage: false,

      allIsValidated: true,

      // Login Daten
      userdata: {},
      session: {},
      loginStatus: false,

      countries_list: [],

      profileLoaded: false

    }
  },
  components: {
      'lightbox': lightbox,
  },
  created() {

    axios.get(process.env.VUE_APP_APIENDPOINT + "/public-api/get-countries/json").then(response => (this.countries_list = response.data));
    
    EventBus.$on('loginSuccessfulSubComponents', (payload) => {
      this.userdata = payload.userdata;
      this.session = payload.session;
      this.loginStatus = true;

      this.loadCreatorProfiles()
      this.loadUserData()
    });
    EventBus.$on('loadUserProfileData', () => {
      this.loadCreatorProfiles()
      this.loadUserData()
    });
    EventBus.$on('collectDataForResultPDF-Step01', () => {
      EventBus.$emit('collectDataForResultPDF-Step02', {
        "appsettings_id": this.selected_project
      });
    });
    EventBus.$on('open_creatorProfiles', () => {
      this.loadCreatorProfiles();
    })
    EventBus.$on('close_creator_profile_update_modal_lightbox', () => {
      this.closeUpdateCreatorProfile();
    })
  },
  methods: {
    loadUserData(){
      if(!this.profileLoaded) {
        let url = process.env.VUE_APP_APIENDPOINT + '/public-api/loadmyprofile/json';
        axios.post(url, this.session)
        .then(response => {
          //(response.data)
          this.userGeneralData = response.data.userData;
          this.profileLoaded = true;
        })
        .catch(function () {
          console.log('catch Function of AJAX-Called... error()');
        });
      }
    },
    loadCreatorProfiles(){
      
      console.log('Loading Creator Profiles Called')
        let url = process.env.VUE_APP_APIENDPOINT + '/quickandlightapp/creators-list/json';
        let currentObj = this;
        axios.post(url, currentObj.session)
        .then(response => {
          console.log(response.data.creators)
          currentObj.creator_profiles = response.data.creators;
          let cP = currentObj.creator_profiles
          for (let i = 0; i < cP.length; i++) {
            if(cP[i].address2 == ' '){
              cP[i].address2 = '';
            }
            if(cP[i].address3 == ' '){
              cP[i].address3 = '';
            }
            if(cP[i].previewimage == ' '){
              cP[i].previewimage = '';
            }
          }
        })
        .catch(function () {
          //console.log('catch Function of AJAX-Called... userprofileError()');
        });
    },
    editCreatorProfile(profile){
      //console.log(profile)
      this.userProfile = profile
      EventBus.$emit('open_updateCreatorProfileModal')

    },
    newCreatorProfile(){
        EventBus.$emit('open_addCreatorProfileModal')
        this.userProfile.id = 0;
        this.userProfile.title = '';
        this.userProfile.previewimage = '';
        this.userProfile.address1 = '';
        this.userProfile.address2 = '';
        this.userProfile.address3 = '';
        this.userProfile.company = '';
        this.userProfile.email = '';
        this.userProfile.phone = '';
        this.userProfile.creator_name = '';
        this.userProfile.country_id = ''
        this.userProfile.freePhone = 0;
        this.userProfile.freeMail = 0;
    },
    addCreatorProfile(){
      //TODO: VALIDATION

      this.allIsValidated = true;

      if(this.userProfile.title == '') {
        this.not_filled_title = true;
        this.allIsValidated = false;
      }
      if(this.userProfile.company == '') {
        this.not_filled_company = true;
        this.allIsValidated = false;
      }
      if(this.userProfile.address1 == '') {
        this.not_filled_address1 = true;
        this.allIsValidated = false;
      }
      if(this.userProfile.country_id == '') {
        this.not_filled_country = true;
        this.allIsValidated = false;
      }
      if(this.userProfile.email == '' && this.userProfile.freeMail == 1) {
        this.not_filled_email = true;
        this.allIsValidated = false;
      }
      if(this.userProfile.phone == '' && this.userProfile.freePhone == 1) {
        this.not_filled_phone = true;
        this.allIsValidated = false;
      }
      if(this.userProfile.creator_name == '') {
        this.not_filled_creator_name = true;
        this.allIsValidated = false;
      }


      if(this.allIsValidated){
        let currentObj = this;
        let data = {};
        data = currentObj.userProfile
        if(currentObj.userProfile.freePhone == 0){
          data.phone = currentObj.userdata.tel;
        }
        if(currentObj.userProfile.freeMail == 0){
          data.email = currentObj.userdata.email;
        }
        let merged = {...data, ...this.session};
        axios.post(process.env.VUE_APP_APIENDPOINT + '/quickandlightapp/creators-actions/add/json', merged)
            .then(function () {
              currentObj.loadCreatorProfiles(); currentObj.createNewModal = false;
              EventBus.$emit('close_addCreatorProfileModal');
              currentObj.resetForm()
            }
        );

       
      }

    },
    selectCreatorProfile(id){
      this.selected_creator_profile = id;

    },
    deleteCreatorProfile(profile){
      let currentObj = this;
      let data = {id: profile.id};
      let merged = {...data, ...this.session};
      axios.post(process.env.VUE_APP_APIENDPOINT + '/quickandlightapp/creators-actions/remove/json', merged)
        .then(function () {currentObj.loadCreatorProfiles()});

    },
    closeAddCreatorProfile(){
      EventBus.$emit('close_addCreatorProfileModal');
      this.loadCreatorProfiles();
      this.resetForm();
    },
    closeUpdateCreatorProfile(){
      EventBus.$emit('close_updateCreatorProfileModal');
      this.loadCreatorProfiles();
      this.resetForm();
    },
    updateCreatorProfile(){
      console.log('update creator profiles called')

      this.allIsValidated = true;

      if(this.userProfile.title == '') {
        this.not_filled_title = true;
        this.allIsValidated = false;
      }
      if(this.userProfile.company == '') {
        this.not_filled_company = true;
        this.allIsValidated = false;
      }
      if(this.userProfile.address1 == '') {
        this.not_filled_address1 = true;
        this.allIsValidated = false;
      }
      if(this.userProfile.country_id == '') {
        this.not_filled_country = true;
        this.allIsValidated = false;
      }
      if(this.userProfile.email == '') {
        this.not_filled_email = true;
        this.allIsValidated = false;
      }
      if(this.userProfile.phone == '') {
        this.not_filled_phone = true;
        this.allIsValidated = false;
      }
      if(this.userProfile.creator_name == '') {
        this.not_filled_creator_name = true;
        this.allIsValidated = false;
      }

      if(this.userProfile.address2 == '') {
        this.userProfile.address2 = ' ';
      }
      if(this.userProfile.address3 == '') {
        this.userProfile.address3 = ' ';
      }
      if(this.userProfile.previewimage == '') {
        this.userProfile.previewimage = ' ';
      }


      if(this.allIsValidated){
        let currentObj = this;
        let data = {};
        console.log(data)
        data = currentObj.userProfile;

        let merged = {...data, ...this.session};
        axios.post(process.env.VUE_APP_APIENDPOINT + '/quickandlightapp/creators-actions/update/json', merged)
          .then(function () {
            console.log('.then update creator profiles')
            currentObj.loadCreatorProfiles(); currentObj.showCreatorProfileEditModal = false;
            EventBus.$emit('close_updateCreatorProfileModal'); 
            currentObj.resetForm();
          });
      }

    },
    changeFreeMail(value){
      if(value == 0){
        this.userProfile.freeMail = 1
        return
      }
      if(value == 1){
        this.userProfile.freeMail = 0
        return
      }
    },
    changeFreePhone(value){
      if(value == 0){
        this.userProfile.freePhone = 1
        return
      }
      if(value == 1){
        this.userProfile.freePhone = 0
        
        return
      }
    },

    selectImage () {
          this.$refs.fileInput.click()
      },
      pickFile () {
        this.previewimage = '';
        let input = this.$refs.fileInput
        let file = input.files
        if (file && file[0]) {
          let reader = new FileReader
          reader.onload = e => {
            this.userProfile.previewimage = e.target.result
          }
          reader.readAsDataURL(file[0])
          this.$emit('input', file[0])
        }
      },

      resetForm(){
        this.not_filled_title = false;
        this.not_filled_firstname = false;
        this.not_filled_lastname = false;
        this.not_filled_company = false;
        this.not_filled_email = false;
        this.not_filled_country = false;
        this.not_filled_address1 = false;
        this.not_filled_creator_name = false;
        this.not_filled_phone = false;
        this.not_same_password = false;
        this.not_old_password = false;
        this.not_filled_previewimage = false;

      }
    
  }

}
</script>

<style scoped>
</style>